import { Check, X } from 'lucide-react';

import Icon from '@/components/Icon.tsx';
import Paragraph from '@/components/text/Paragraph.tsx';

import type { PreBookedCollectionAppointment } from '@/schemas/chain-booking.schema.ts';

import { dayjs } from '@/utils/dayjsSetup.ts';

interface Props {
    appointments: PreBookedCollectionAppointment[];
    showDeleted?: boolean;
}

export const CollectionSuccessNotification = ({ appointments, showDeleted }: Props) => {
    return (
        <div className="mt-1 flex flex-col gap-1">
            {appointments.map((apt) => {
                const start = dayjs(apt.start);
                const end = dayjs(apt.end);
                return (
                    <div key={apt.id} className="flex items-center gap-1.5">
                        <Icon
                            icon={showDeleted ? X : Check}
                            size="size-3.5"
                            className={showDeleted ? 'shrink-0 text-red-600' : 'shrink-0 text-green-600'}
                        />
                        <Paragraph className={`text-[13px] ${showDeleted ? 'text-red-700 line-through' : ''}`}>
                            {start.format('dd, D. MMM YYYY')} — {start.format('HH:mm')} - {end.format('HH:mm')}
                        </Paragraph>
                    </div>
                );
            })}
        </div>
    );
};
